import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * custom hooks for retrieving data
 * @param {*} fetchFunction
 * @returns
 */

const useFetchData = (fetchFunction) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isSuccess, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [shouldFetch, refetch] = useState({});
  const refresh = () => refetch({});
  const abortController = new AbortController();

  useEffect(() => {
    async function fetchData() {
      try {
        const signal = abortController.signal;
        const res = await fetchFunction(signal);
        if (res.status === 200) {
          setData(res.data.data);
          setSuccess(true);
        } else if (res.status === 403) {
          navigate('/permission/denied/');
        }
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();

    return () => {
      abortController.abort();
    };
  }, [shouldFetch]);

  return { data, isLoading, isSuccess, error, refresh };
};

const useFetch = (fetchFunction) => {
  const { data, isLoading, isSuccess, error, refresh } =
    useFetchData(fetchFunction);

  return { data, isLoading, isSuccess, error, refresh };
};

export default useFetch;
